export enum DialogType {
  Message = "MESSAGE",
  Content = "CONTENT",
  TabContent = "TABCONTENT",
  FullScreen = "FULLSCREEN",
  FullScreenNoSpeedDial = "FULLSCREENNOSPEEDDIAL",
  ImageZoom = "IMAGEZOOM",
  WalkingMan = "WALKINGMAN",
  Selection = "SELECTION",
  Simple = "SIMPLE",
  BankIdSign = "BANKIDSIGN",
  Wizard = "WIZARD",
}
